var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none;stroke: #e27935;stroke-linecap: round;stroke-linejoin: round;stroke-width: 40 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape 2",
    className: "s0",
    d: "m53.1 176.8l84.5-94.6 93.6 102.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 2",
    className: "s0",
    d: "m138.8 83.4v331.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 2",
    className: "s0",
    d: "m441.9 320.2l-84.5 94.6-93.6-102.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 2",
    className: "s0",
    d: "m356.2 413.6v-331.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.12d0c02be9f1ba21837c847f5a8f7c6a.svg";
export { ForwardRef as ReactComponent };